import { Flex, Input } from 'antd';
import { Filter, Form } from 'components';
import { FilterControlButtons } from 'components/form/FilterControlButtons';
import { CommoditiesSelect } from '@/components/form/select/CommoditiesSelect';
import type { Paths } from 'type-fest';
import {
  DEFAULT_FILTER,
  type MeterModelsFilterShape,
  useMeterModelsFilterWithPagination,
} from '../hooks/useMeterModelsFilterWithPagination';

export const MeterModelsFilter = () => {
  const [form] = Form.useForm<MeterModelsFilterShape>();

  const { filter, setFilterState, resetFilterState, setPaginationState } = useMeterModelsFilterWithPagination();

  const handleReset = () => {
    form.setFieldsValue(DEFAULT_FILTER);

    resetFilterState();
    setPaginationState({
      current: 1,
    });
  };
  return (
    <Filter form={form} initialValues={filter} onFinish={setFilterState}>
      <Form.Item label="Search" name={'search' satisfies Paths<MeterModelsFilterShape>}>
        <Input allowClear placeholder="Search model" />
      </Form.Item>

      <Form.Item label="Commodity" name={'commodity' satisfies Paths<MeterModelsFilterShape>}>
        <CommoditiesSelect />
      </Form.Item>
      <Flex align="end" flex={2} justify="space-between">
        <FilterControlButtons onClickReset={handleReset} />
      </Flex>
    </Filter>
  );
};
